import { Button, Col, DatePicker, message, Row, Select } from "antd";
import useReceptionistMobilePickerProps from "../../../Receptionist/receptionistMobilePickerProps";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import useQuery from "../../../../hooks/useQuery";
import {
  downloadEmrApi,
  getEmrDownloadApi,
} from "../../../../services/discharge.services";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { DownloadOutlined } from "@ant-design/icons";
import FormContentLoader from "../../FormsIp/FormContentLoader";
import ScaledHtmlPreview from "../../../ui/ScaledHtmlPreview";

const dateFormat = "YYYY-MM-DD";
const EmrDownload = () => {
  const curDate = dayjs().format(dateFormat);
  const [data, setData] = useState(null);
  const [date, setDate] = useState(curDate);
  const params = useQuery();
  // Anchors the popup to the field like the other date filters, instead of the
  // fixed centred panel the global ≤1200px rule applies to unclassed pickers.
  const mobilePickerProps = useReceptionistMobilePickerProps();
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState("Doctor");

  useEffect(() => {
    setLoading(true);
    setData(null);
    getEmrDownloadApi(
      params?.patient,
      `date=${date}&practitioner=${selectedRole}`
    )
      .then((res) => {
        setData(res?.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [date, selectedRole, params?.patient]);

  const disabledDate = (current) => current && current > dayjs().endOf("day");

  const onDateChange = (date, dateString) => {
    setDate(date ? dateString : null);
  };

  const download = () => {
    setBtnLoading(true);
    downloadEmrApi(
      params?.patient,
      `date=${date}&practitioner=${selectedRole}&response_type=file`
    )
      .then((response) => {
        if (response?.data?.link) {
          const link = document.createElement("a");
          link.href = response.data.link;
          link.setAttribute("target", "_blank");
          link.download = `${selectedRole}_emr_${date}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          message.error("Failed to retrieve the download link.");
        }
      })
      .catch((error) => {
        message.error("Download failed. Please try again.");
        console.error("Download Error:", error);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  const userRoles = ["Doctor", "Nurse", "Physiotherapist"];

  return (
    <Row>
      <Col span={24} className="flex-end emr-download-toolbar">
        <Select
          style={{ width: "150px", marginRight: "10px" }}
          className={inputStyles.mdSelect}
          onChange={(val) => setSelectedRole(val)}
          value={selectedRole}
        >
          {userRoles.map((item) => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
        <DatePicker
          style={{
            border: "1px solid #a182e3",
            height: "38px",
            width: "150px",
          }}
          disabledDate={disabledDate}
          className={inputStyles.mdDateInput}
          onChange={onDateChange}
          defaultValue={dayjs(curDate)}
          allowClear={false}
          {...mobilePickerProps}
        />
        <Button
          style={{ marginLeft: "10px" }}
          icon={<DownloadOutlined />}
          type="primary"
          size="large"
          onClick={download}
          loading={btnLoading}
        >
          Export
        </Button>
      </Col>
      <Col span={24}>
        <FormContentLoader
          loading={loading}
          tip={`Loading ${selectedRole} EMR...`}
        >
          {data ? (
            <ScaledHtmlPreview
              html={data}
              designWidth={900}
              className="ip-form-html-preview"
            />
          ) : (
            !loading && <p>No EMR data available for this selection.</p>
          )}
        </FormContentLoader>
      </Col>
    </Row>
  );
};

export default EmrDownload;
